//import React from "react";
import React, { useEffect, useState } from "react";
import Footer from "components/Footer/Footer";
import Admin from "layouts/Admin";

//import validator from 'validator'
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";

import firebase from "../firebase";

const UpdateShedulerDetails=(props)=> {

//Stroring Reteriwing Data
const [firstname, setFirstName] = useState("");
const [lastname, setLastName] = useState("");
const [StartTime, setAStartTime] = useState("");
const [EndTime, setAEndTime] = useState("");
const [Date, setAdate] = useState("");
const [AboutMe, setAabtme] = useState("");

 useEffect(()=>{

//  setID(props.match.params.id)
 const files = firebase.database().ref("assignshedules").child(props.match.params.id);
  files.on('value', (snapshot)=>{
    const dataList = snapshot.val();
   
    setFirstName(dataList?.FirstName);
    setLastName(dataList?.LastName);
    setAStartTime(dataList?.StartTime);
    setAEndTime(dataList?.EndTime);
    setAdate(dataList?.Date);
    setAabtme(dataList?.AboutMe);
    
  }) 


 },[]);

 const updateData = (e) => {
  // var email = email;   
       
  // if (validator.isEmail(email)) {
          // setEmailError(false);
  
  console.log(props.match.params.id)
  const files = firebase.database().ref("assignshedules").child(props.match.params.id);
  
  let data = {
    
    FirstName:firstname,
    LastName:lastname,
    StartTime: StartTime,
    EndTime: EndTime,
    Date :Date,
    AboutMe: AboutMe,
    
    
  };
  files.update(data);
  alert("Succfully Updated");
  
  setFirstName("");
  setLastName("");
  setAStartTime("");
  setAEndTime("");
  setAdate("");
  setAabtme("");
  

// }
            
//   else {
//           setEmailError(false);  
//   } 
 }

    return (
      <>


 
      <Admin/>
  
  <br/>
  
  <Container>
    <Row>
      <Col md={{ span: 12, offset: 1 }}>  

      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Update Roster Details</Card.Title>
                <Form className="d-flex">
     
    </Form>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>First Name</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="firstname"
                          type="text"
                          //readOnly
                          focus value = {firstname} onChange={(e)=>{setFirstName (e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>Last Name</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="lastname"
                          //readOnly
                          type="text"
                          focus value = {lastname} onChange={(e)=>{setLastName(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                            Start Time
                        </label>
                        <Form.Control
                          placeholder="starting time"
                          type="time"
                          focus value = {StartTime} onChange={(e)=>{setAStartTime(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label>Ending Time</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="ending time"
                          type="time"
                          focus value = {EndTime} onChange={(e)=>{setAEndTime(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label>Date</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="date"
                          type="date"
                          focus value = {Date} onChange={(e)=>{setAdate(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>About the Trip</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="about the trip"
                          type="text"
                          focus value = {AboutMe} onChange={(e)=>{setAabtme(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    
                  </Row>

                  <Button onClick={(e)=>updateData()} variant="primary" size="" active>
                  Update
                </Button>{' '}

                </Form>
              </Card.Body>
            </Card>
          </Col>
          
        </Row>
      </Container>

      </Col>
  </Row>
</Container>

<Footer /> 

    </>

     ) ;
    }



export default UpdateShedulerDetails;